import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled',
    '[class.uppercase]': 'uppercasedText',
  },
})
export class TabComponent {
  @Input() public isUnread: boolean = false;
  @Input() public count: number | string = 0;
  @Input() public href: string;
  @Input() public hrefTarget: string;
  @Input() public disabled: boolean = false;
  @Input() public noRightPadding: boolean = false;
  @Input() public uppercasedText: boolean = true;
}
